var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      !_vm.bottom
        ? _c("campaign-tag-curve", {
            staticClass: "curve -left",
            attrs: { "is-cashback": _vm.isCashback, reverse: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("campaign-tag-curve", {
        class: ["curve -right", { "-bottom": _vm.bottom }],
        attrs: { "is-cashback": _vm.isCashback }
      }),
      _vm._v(" "),
      _vm.isExclusive
        ? _c("campaign-tag-curve", {
            staticClass: "curve -right",
            attrs: { "is-exclusive": _vm.isExclusive }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.rescue && _vm.showDiscontTag
        ? _c(
            "figure",
            {
              class: [
                "-discount tag",
                { "-cashback": _vm.isCashback, "-bottom": _vm.bottom }
              ]
            },
            [
              _vm.value
                ? _c("figcaption", {
                    domProps: { textContent: _vm._s(_vm.value) }
                  })
                : _vm.isFromNow && !_vm.isExclusive
                ? _c("figcaption", { staticClass: "-from-now" }, [
                    _vm._v(
                      "\n      De " +
                        _vm._s(_vm.formatMoney(_vm.discountValue)) +
                        " por " +
                        _vm._s(_vm.formatMoney(_vm.fromNowDiscountValue)) +
                        "\n    "
                    )
                  ])
                : _vm.isFromNow && _vm.isExclusive
                ? _c("figcaption", { staticClass: "-cashback-engagement" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.formatMoney(
                            _vm.discountValue - _vm.fromNowDiscountValue
                          )
                        ) +
                        " OFF\n    "
                    )
                  ])
                : _vm.isAward || _vm.isEngagement
                ? _c("figcaption", {
                    staticClass: "-cashback-engagement",
                    domProps: {
                      textContent: _vm._s(_vm.isAward ? "Prêmio" : "Recompensa")
                    }
                  })
                : _c(
                    "figcaption",
                    { class: [{ "-twoForOne": _vm.discount === "2x1" }] },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.isCashback
                              ? _vm.discount + " de volta"
                              : _vm.discount
                          ) +
                          "\n    "
                      )
                    ]
                  )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isExclusive
        ? _c(
            "section",
            {
              class: [
                "exclusive",
                { "only-exclusive": _vm.isExclusive && _vm.rescue }
              ]
            },
            [
              _c("campaign-tag-curve", {
                staticClass: "curve -center",
                attrs: { "is-exclusive": "", reverse: "" }
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.isExclusive && _vm.rescue
                ? _c("campaign-tag-curve", {
                    staticClass: "curve -right",
                    attrs: { "is-exclusive": "" }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "-exclusive tag" }, [
      _c("figcaption", [_vm._v("EXCLUSIVO")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cbb787b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cbb787b","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaign/CampaignTag.vue
// module id = 2118
// module chunks = 1610